import createCache from "@emotion/cache"
import rtlPlugin from "@mui/stylis-plugin-rtl"

export const createEmotionCache = (direction = "ltr") => {
  if (direction === "rtl") {
    return createCache({
      key: "muirtl",
      stylisPlugins: [rtlPlugin],
    })
  }
  return createCache({ key: "mui" })
}
